import { useEffect, useState } from 'react';

import mailcheck from 'mailcheck';

export function useMailcheck(email?: string) {
  const [suggestion, setSuggestion] = useState<MailcheckModule.ISuggestion | null>(null);
  useEffect(() => {
    mailcheck.run({
      email: email || '',
      suggested: (suggestionObject: MailcheckModule.ISuggestion) => {
        setSuggestion(suggestionObject);
      },
      empty: () => {
        setSuggestion(null);
      },
    });
  }, [email]);

  return suggestion;
}

export default useMailcheck;
